import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const StudioBiEventsExtension = ModuleExtensions.biEventsExtension();
//# sourceMappingURL=studio-bi-events.extension.js.map